import emailjs from "emailjs-com";
import { OrderModel } from "../../models/order-model";
import { ProductModel } from "../../models/product-model";
import { EmailTemplates } from "./EmailTemplates";
import { utilities } from '../../helpers/utilities';

const service_id = "service_wpndfzn";
const user_id = "user_8d2seNPcXe9oVaeOXhQBB";
let template_params: any = { from_name: "Cava Don Carlos" };

export async function sendNewPasswordEmail (email: any, newPassword: any, templateId: EmailTemplates.RenewPassword) {
    
    template_params = {
        ...template_params,
        "email": email,
        "newPassword": newPassword
    }

    await sendEmail(templateId, template_params);
}

export async function sendOrderConfirmation(email: string, order: OrderModel, templateId: EmailTemplates.OrderConfirmation) {
    let orderProductsRows = '';
    order.products.forEach(
        (prod: ProductModel, idx) => {
            const charge = (prod.qty ?? 1) * prod.cost;
            let borderStyle = '';
            if ((idx) === order.products.length - 1) {
                borderStyle = 'border-bottom: 2px solid gray';
            }
            orderProductsRows += `<tr>
                <td style="padding: 10px 30px; ${borderStyle}">${prod.qty}</td>
                <td style="padding: 10px 30px; ${borderStyle}">${prod.full_name}</td>
                <td style="padding: 10px 30px; text-align: right; ${borderStyle}">${utilities.formatMoney(charge)}</td>
            </tr>`;
        }
    );

    const orderSummary = `
        <tr>
            <td style="padding: 10px 30px;"></td>
            <td style="padding: 10px 30px;text-align: right; font-weight: bold;">Subtotal</td>
            <td style="padding: 10px 30px; text-align: right;">${utilities.formatMoney(order.productsTotal)}</td>
        </tr>
        <tr>
            <td style="padding: 10px 30px;"></td>
            <td style="padding: 10px 30px;text-align: right; font-weight: bold;">Envío</td>
            <td style="padding: 10px 30px; text-align: right;">${utilities.formatMoney(order.deliveryCharge)}</td>
        </tr>
        <tr>
            <td style="padding: 10px 30px;"></td>
            <td style="padding: 10px 30px;text-align: right; font-weight: bold;">Impuesto</td>
            <td style="padding: 10px 30px; text-align: right;">$0.00</td>
        </tr>
        <tr>
            <td style="padding: 10px 30px;"></td>
            <td style="padding: 10px 30px;text-align: right; font-weight: bold;">Total</td>
            <td style="padding: 10px 30px; text-align: right;">${utilities.formatMoney(order.orderTotal)}</td>
        </tr>`;

    const orderProductsTable = `<table><tbody>${orderProductsRows}${orderSummary}</tbody></table>`;

    template_params = {
        ...template_params,
        client_name: order.userDetails.name,
        cp: order.userDetails.address.cp,
        district: order.userDetails.address.district,
        email,
        orderProductsTable,
        order_number: order.number,
        street: order.userDetails.address.street
    };
    
    await sendEmail(templateId, template_params);
}


const sendEmail = (templateId: EmailTemplates, templateParams: any) => {
    return emailjs.send(service_id, templateId, templateParams, user_id)
        .then((result) => {
            return true;
        })
        .catch(error => {
            return false;
        }); 
}